import { render, staticRenderFns } from "./ProjectManagementArchive.vue?vue&type=template&id=52f36410&"
import script from "./ProjectManagementArchive.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports